import { useMutation, useQueryClient } from '@tanstack/react-query';

import { engagementResourcesService } from '../services';
import type { CreateResourceInput } from '../types';

import { engagementResourcesKeys } from './useEngagementResources';

export function useCreateResource() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateResourceInput) => engagementResourcesService.create(input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: engagementResourcesKeys.lists() });
    },
  });
}
